/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function isCompare(context) {
	const {
		boardModel: { layout }
	} = context;


	const id = layout.exploreVM.displayedCard;
	const card = layout.findModel(id);
	const visualizations = card && card.getVisualizations();

	// Selection should be disabled for cards with only 1 visualization.
	return visualizations && visualizations.length > 1;
}

/**
 * Returns a selector that is used to determine what touch/pointer-events will result in the
 * deselection of widgets. Any event target (node) that is not a child of the nodes found
 * by this selector will not result in widgets being deselected.
 *
 * @return {string} a selector
 */
export default (context) => {
	return isCompare(context) ? '.card-layout-main' : '.card-row';
};


// WEBPACK FOOTER //
// ./src/js/layout/interactions/Deselection.js